import {mustache} from "../handlebars_family.js";
import $ from '../$.js'
import * as FwDatas from "../FwDatas.ts";
// a set of functions to initialize widgets and custom decorations in HTML
type Widget = {init:(a:any)=>void , destroy?:(a:any)=>void}

var 
  widgetDefinition : {[x: string]: Widget} = {},
  currentSkin :string,
  widgetNodes = [],
  decorators = [/*decorator for widget*/function(nodes){ 
    nodes.find("[data-widget]").add(nodes.filter("[data-widget]")).each(function(idx,nodeWithWidget){
      nodeWithWidget = $(nodeWithWidget);
      //with amd it was asynchronous, if not some widget does not work well so we redo this like before with a setTimeout
      setTimeout(()=>{
        nodeWithWidget.attr('data-widget').split(/\s/g).forEach(widgetName=>{
          if(widgetDefinition[widgetName]){
            widgetDefinition[widgetName].init(nodeWithWidget)
          }else{
            console.log("Please ADD \nHtml.registerWidget('"+widgetName+"',{init,destroy})")
          }
          
        })
      },1)
      widgetNodes.push(nodeWithWidget);
    });
  },function(nodes){  
    //remove animated class because it causes issue with action-menu
    var animatedNodes = nodes.find(".animated").add(nodes.filter(".animated"));
    if(animatedNodes.length){
      setTimeout(function(){
        animatedNodes.each(function(idx,animatedNode){
          $(animatedNode).removeClass('animated')
        })
      },1000)
    }
  }],
  cleaners = [/*cleaner for widget*/function(nodes){  
    nodes.find("[data-widget]").add(nodes.filter("[data-widget]")).each(function(idx,nodeWithWidget){
      nodeWithWidget = $(nodeWithWidget);
      
      //give the same jquery objet to the destroy method, so if we did obj.toto we can get back what we put in toto
      for(let i=0;i<widgetNodes.length;i++){
        if(nodeWithWidget.is(widgetNodes[i])){
          nodeWithWidget = widgetNodes[i];
          widgetNodes.splice(i, 1);
          break;
        }
      }
      nodeWithWidget.attr('data-widget').split(/\s/g).forEach(widgetName=>{
        if(widgetDefinition[widgetName]){
          if(widgetDefinition[widgetName].destroy){
            widgetDefinition[widgetName].destroy(nodeWithWidget)
          }
        }
        
      })
      
    });
  },/*cleaner for video tag*/
  function(nodes){
    //when we clean a video we want it to stop downloading in order to preserve bandwith
    //the equivalent for images does not work
    nodes.find('video').each(function(this:HTMLVideoElement){
      this.pause();
      this.src ="";
      $(this).remove();
    });
  }];

function checkInputTypeSupported(type :string) {
    var input = document.createElement("input");
    input.setAttribute("type", type);
    return input.type == type;
}
if(!checkInputTypeSupported('datetime-local')){
  decorators.push(function(nodes){
    nodes.find("input[type='datetime-local']").each(function(idx,nodeWithWidget){
      nodeWithWidget.placeholder = "yyyy-mm-ddThh:mm";
      nodeWithWidget.pattern = "[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}";
    })
  })
}
/*
Function: initHtml(node)
Initialize widgets and custom decorations in given node

Parameters:
  node - object, jQuery object wrapping the parent element of the new html
  mustacheName - string, name of the Mustache template
  data - optional, object, data with values to replace in template,
    defaults to {} to replace only localization keys
*/
function initHtml(nodes :JQuery){
  decorators.forEach(function(decorator){
    decorator(nodes);
  });
  return nodes;
}
function cleanHtml(nodes:JQuery){
  cleaners.forEach(function(cleaner){
    cleaner(nodes);
  });
}

/*
Function: setHtml(node,mustacheName,data)
Replace data in template with given name and insert HTML in node

After inserting the HTML, widgets and custom decorations are initialized
using initHtml().

Parameters:
  node - object, jQuery object wrapping the parent element of the new html
  mustacheName - string, name of the Mustache template
  data - optional, object, data with values to replace in template,
    defaults to {} to replace only localization keys
*/
function setHtml(node:JQuery, mustacheName :MUS, data :any){
  cleanHtml(node.children());
  node.html(
    mustache(mustacheName,data)
  );
  return initHtml(node.children());
}
function setHtmlArray(node:JQuery, mustacheName :MUS, array :any[]){
  cleanHtml(node.children());
  node.html(
    array.map(data=>mustache(mustacheName,data)).join('')
  );
  return initHtml(node.children());
}
/**
* TODO : find a way to make it work if selector is several node
* replace a selector by execution of a mustache
* return true if the node exists
*/
function replaceWith(selector :string,mustacheName :MUS,data :any){
  var el :JQuery = $(selector);
  if(el.length===0){
    return undefined;
  }
  var 
    replaced :JQuery;
  
  cleanHtml(el);
  
  el.each(function(idx,node){
    if(idx!=0) $(node).remove()
    else{
      replaced = $(mustache(mustacheName,data))
      $(node).replaceWith(replaced);
    }
  })
  return initHtml(replaced);
}

function enableComments(el:JQuery){
  if(el.length===0){
    return false;
  }
  el.contents().each(function(idx,node){
    if(node.nodeType === 8){
      $(node).replaceWith(node.data);
    }
  });
  initHtml(el);
  return true;
}


/*
Function: setHtmlAtStart(node,mustacheName,data)
Replace data in template with given name and prepend HTML at start of node

After inserting the HTML, widgets and custom decorations are initialized
using initHtml().

Parameters:
  node - object, jQuery object wrapping the parent element of the new html
  mustacheName - string, name of the Mustache template
  data - optional, object, data with values to replace in template,
    defaults to {} to replace only localization keys
*/
function setHtmlAtStart(node:JQuery, mustacheName :MUS, data :any){
  if (node.children().length===0){
    return setHtml(node,mustacheName,data);
  }
  
  var firstNode = node.children().first();
  node.prepend(
    mustache(mustacheName,data)
  );
  var result = firstNode.prevAll();
  initHtml(result);
  return result;
}

/*
Function: setHtmlAtEnd(node,mustacheName,data)
Replace data in template with given name and append HTML at end of node

After inserting the HTML, widgets and custom decorations are initialized
using initHtml().

Parameters:
  node - object, jQuery object wrapping the parent element of the new html
  mustacheName - string, name of the Mustache template
  data - optional, object, data with values to replace in template,
    defaults to {} to replace only localization keys
*/
function setHtmlAtEnd(node:JQuery|null, mustacheName :MUS, data :any){
  if (node.children().length===0){
    return setHtml(node,mustacheName,data);
  }
  
  var lastNode = node.children().last();
  node.append(
    mustache(mustacheName,data)
  );
  var result = lastNode.nextAll();
  initHtml(result);
  return result;
}

var 
 actions :namedOnclick = {
    none(){
    }
 },
 runningClick=false,
 runningClickTimeout;

function isRunningClick(){
  return runningClick;
}
function runClick(){
  runningClick = true;
  clearTimeout(runningClickTimeout);
  runningClickTimeout = setTimeout(function(){runningClick=false},50)
}

function createDelegateListener(selector:string,listener :(event:Event,target:HTMLElement)=>boolean|undefined){
  return function(event :Event){
    var 
      crawler = event.target as HTMLElement;
    while(crawler!==null){
      if(crawler.matches(selector)){
        if(listener(event,crawler)!==true){
          return;
        }
      }
      crawler = crawler.parentElement;
    }
  }
}
document.addEventListener("click",createDelegateListener("[data-fw-onclick]",function(event,target){
  event.preventDefault();
  var
    onclick = target.getAttribute("data-fw-onclick"),
    params = onclick.split('|'),
    rawActionName = params[0],
    actionName = FwDatas.getPermission(rawActionName),
    action = actions[actionName];

 if(action){
    runClick();
    return action.apply($(target),params.slice(1))  
  }else{
    throw new Error("no action for "+onclick+" ("+rawActionName+" => "+actionName+" )");
  }
}))


export function fwtrigger(node :string|JQuery|HTMLElement,rawActionName?:string|string[],params?:string|string[]){
  var 
    realNode = null;
  if(typeof node==='string'){
    params = rawActionName;
    rawActionName = node;
  }else{
    realNode = $(node);
  }
  var 
    actionName = FwDatas.getPermission(rawActionName),
    action = actions[actionName];
  
  if(action){
    action.apply(realNode,params);
  }else{
    throw new Error("no action for "+rawActionName+" ("+rawActionName+" => "+actionName+" )");
  }
};
function triggerbystring(node,str){
  var 
    params = str.split('|'),
    rawActionName = params[0];
  
  fwtrigger(node,rawActionName,params.slice(1));
}
/**
 * 
 * @param {*} obj 
 * @param {*} before a function that return a promise that load everything is needed for doing all methods in obj 
 */
function register(obj :namedOnclick, before :Function = undefined){
  Object.entries(obj).forEach(([key,obj])=>{
    /*
    if(obj.toString().indexOf('this')>-1){
      console.log(obj.toString())
    }*/
    if(actions[key]){
      throw new Error("cannot define the same action twice : "+key);
    }else{
      if(before){
        actions[key] = async function(...args){
          await before();
          return obj.apply(this,args)
        }
      }else{
        actions[key] = obj;
      }
    }
  });
}
export function registerWidget(key :string,obj :Widget){
  if(widgetDefinition[key]){
    console.log(new Error("cannot define the same widget twice : "+key));
  }else{
    widgetDefinition[key] = obj;
  }
}
var 
  trigger = fwtrigger;

function wait(clause,then){
  var interval = setInterval(function(){
    if(clause()){
      clearInterval(interval);
      then();
    }
  },50)
}

function changeSkin(title) {
  // a.getAttribute will return null and not undefined so to avoid to use != but !== we change requested title
  if(title===undefined){
    title=null;
  }
  if(title===currentSkin){
    return false;
  }else{
    currentSkin = title;
  }
  
  return true;
}
const escaperNode = document.createElement('div');
function escape(unsafeString :string){
  escaperNode.innerText = unsafeString;
  return escaperNode.innerHTML;
}
function getIdOrGenerate(node,prefix='gen'){
  node = $(node);
  let id = node.attr('id');
  if(!id){
    id = prefix+(new Date().getTime()%10800000)+''+(Math.random()*Math.pow(2,30)>>0);
    node.attr('id',id)
  }
  return id;
}

window.Html =  {
  escape,
  initHtml,
  cleanHtml,
  replaceWith,
  enableComments,
  setHtmlAtStart,
  setHtmlAtEnd,
  setHtml,
  mustache,
  
  isRunningClick,
  runClick,
  register,
  trigger,
  triggerbystring,
  registerWidget,
  changeSkin,
  getIdOrGenerate,
  wait
};
export {
  escape,
  initHtml,
  cleanHtml,
  replaceWith,
  enableComments,
  setHtmlAtStart,
  setHtmlAtEnd,
  setHtml,
  setHtmlArray,
  mustache,
  
  isRunningClick,
  runClick,
  register,
  trigger,
  triggerbystring,
  changeSkin,
  getIdOrGenerate,
  wait
}